
import { Options, Vue } from 'vue-class-component'

@Options({})
export default class Disclaimer extends Vue {

    created(): void {
        this.$meta.use({
            title: 'Disclaimer | StatHub.gg',
            og: {
                image: '/img/icons/android-chrome-maskable-192x192.png',
                description: 'StatHub.gg - Disclaimer.'
            }
        })
    }

}
